import * as React from 'react'
import { connect } from 'react-redux'
import {
    CardBody,
    Row,
    CardHeader,
    Col,
    Collapse,
    Input,
    Label,
    Form, FormGroup
} from "reactstrap";
import {WithTranslation, withTranslation} from "react-i18next";
import {CurrencyProps, LinkType} from "App/constants";
import {basketLeasingSelectionChange} from "App/basket";
import {CurrentConfigurationLeasing} from "App/services/api";
import {Element} from "react-scroll/modules";

interface StateToProps extends CurrencyProps {
    leasingdurationmonths: Array<number>
    leasinginitialpayments: Array<number>
    leasing: CurrentConfigurationLeasing | undefined
}

interface DispatchToProps {
    onSelectLeasing: (selected: boolean, durationmonths: number|undefined, initialpaymentpercent:number|undefined) => void
}

const mapDispatchToProps = (dispatch: any) : DispatchToProps => ({
    onSelectLeasing: (selected: boolean, durationmonths: number|undefined, initialpaymentpercent:number|undefined) => dispatch(basketLeasingSelectionChange(selected, durationmonths, initialpaymentpercent))
});

interface ComponentState {
    isVisible: boolean
}

function initialState (props: StateToProps): ComponentState {
    return {
        isVisible: !!props.leasing
    }
}

class _Component extends React.PureComponent<StateToProps & DispatchToProps & WithTranslation, ComponentState> {

    constructor(props: StateToProps & DispatchToProps & WithTranslation, context: any) {
        super(props, context);
        this.state = initialState(props);
    }

    toggleVisibility() {
        this.setState((state, props) => ({
            isVisible: !state.isVisible
        }));
    }

    render() {
        const {currency, leasingdurationmonths, leasinginitialpayments, leasing,
            t, onSelectLeasing} = this.props;
        const leaseDuration: number = leasing&&leasing.durationmonths||leasingdurationmonths[0];
        const leasePrepay: number = leasing&&leasing.initialpaymentpercent||leasinginitialpayments[0];
        return <Element name={LinkType.LEASIG_SECTION}>
            <CardHeader className="px-5 d-flex align-items-center py-3 bg-white toggable" onClick={() => this.toggleVisibility()}>
                <span className="m-0 w-75 float-left title-normal-uppercase">{ t('products.configuration.lease')}</span>
                <i className={'far fa-lg w-25 text-right ' + (this.state.isVisible? 'fa-chevron-up' : 'fa-chevron-down')}></i>
            </CardHeader>
            <Collapse isOpen={this.state.isVisible}>
                <CardBody className="px-5 pt-2 pb-3 bodyslice">
                    <Row className="no-gutters">
                        <Col className="align-items-center py-2 pr-0 col-sm-8">
                            <div className="form-check">
                                <Input type="checkbox" checked={!!leasing} id={"optionInputLeasing"} name={"optionInputLeasing"} className="align-middle"
                                       onChange={(e) => onSelectLeasing(e.target.checked,
                                           leaseDuration,
                                           leasePrepay)}/>
                                <Label htmlFor={"optionInputLeasing"} className="py-0 text-normal-details light align-middle">{ t('products.configuration.createlease')}</Label>
                            </div>
                        </Col>
                        <Col className="align-items-center py-2 pl-0 col-sm-4 text-right">
                            <Label className="pl-2 py-0 text-normal-details light align-middle">{leasing&&leasing.monthlyrate?t('products.configuration.leaseprice', {amount:leasing.monthlyrate, unit:currency}):null}</Label>
                        </Col>
                    </Row>
                    <Row className="no-gutters">
                        <Col className="align-items-center pr-0 col-sm-6">
                            <Form inline>
                                <FormGroup>
                                    <Label for="leaseDuration" className={"text-normal-details light pl-5"}>{ t('products.configuration.leaseduration')}</Label>
                                    <Input type="select" name="leaseDuration" id="leaseDuration" className={"text-select-details light ml-3"} disabled={!leasing}
                                           value={leaseDuration}
                                           onChange={(e) => onSelectLeasing(true, Number(e.target.value), leasePrepay)}>
                                        {
                                            leasingdurationmonths.map((month:number, index: number) => (
                                                <option key={month} value={month}>{t('products.configuration.leasemonth', {month: month})}</option>
                                            ))
                                        }
                                    </Input>
                                </FormGroup>
                            </Form>
                        </Col>
                        <Col className="align-items-center pl-0 col-sm-6">
                            <Form inline>
                                <FormGroup>
                                    <Label for="leasePrepay" className={"text-normal-details light pl-5"}>{ t('products.configuration.leaseprepay')}</Label>
                                    <Input type="select" name="leasePrepay" id="leasePrepay" className={"text-select-details light ml-3"} disabled={!leasing}
                                           value={leasePrepay}
                                           onChange={(e) => onSelectLeasing(true, leaseDuration, Number(e.target.value))}>
                                        {
                                            leasinginitialpayments.map((percent:number, index: number) => (
                                                <option key={percent} value={percent} selected={leasing&&percent===leasing.initialpaymentpercent}>{t('products.configuration.leasepercent', {percent: percent})}</option>
                                            ))
                                        }
                                    </Input>
                                </FormGroup>
                            </Form>
                        </Col>
                    </Row>
                </CardBody>
            </Collapse>
        </Element>
    }
}

export const Component = connect(null, mapDispatchToProps)(withTranslation('common')(_Component));


// WEBPACK FOOTER //
// ./src/components/LeasingConf.tsx